/* eslint-disable */
import React, { useEffect, useState } from "react";
import * as API from "../../framework/API/api"
import { ENTITYNAME, LOGEVENT, MODULE, TOAST_TYPES } from "../../framework/constant/constant";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { EditPageHeader } from "../../components/EditPageHeader";
import { useTranslation } from "../../locale/useTranslation";
import BossDialog from "../../components/BossDialog";
import { utility } from "../../framework/utility/utilityProvider";
import ToastNotification from "../../components/ToastNotification";

const ContentCategoryEditForm = (props) => {

    const { item = {}, refresh, cancelEdit } = props;

    const blankDataItem = {
        ...item,
        SID: item.SID ?? 0,
        Name: item.copy ? "Copy of " + item.Name : item.Name ?? "",
        Language: item?.Language ?? {},
        Archive: item?.Archive ?? false
    };

    const [dataItem, setDataItem] = useState(blankDataItem);
    const [parents, setParents] = useState([]);
    const [parent, setParent] = useState({});
    const [languages, setLanguages] = useState([]);
    const lang = useTranslation();

    useEffect(() => {
        loadCombo();
    }, [])

    const loadCombo = async () => {
        let languagesRes = await API.getDataLookup(ENTITYNAME.Language, { sort: { Description: 1 } });
        setLanguages(languagesRes.data);
        if (item?.SID == 0) {
            setDataItem({ ...dataItem, Language: utility.getDefaultItem(languagesRes.data) })
        } else {
            setDataItem({ ...dataItem, Language: item?.Language && Object.keys(item?.Language).length > 0 ? item?.Language : utility.getDefaultItem(languagesRes.data) });
        }
        let parentRes = await API.getDataLookup(ENTITYNAME.ContentCategory);
        if (parentRes.success) {
            const nullItem = { _id: null, SID: Math.random(), Archive: false, Name: "root", parent: null };
            setParents([nullItem, ...parentRes.data]);
            if (item.copy || item.SID > 0 || item?.parent) {
                setParent(item.parent == null ? nullItem : parentRes.data.find(x => x._id == item.parent));
            }
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: parentRes.message });
        }
    };

    const onChange = (e) => {
        if (e.target.name == "Archive") {
            setDataItem({ ...dataItem, Archive: !dataItem.Archive });
        } else if (e.target.name == "parent") {
            setParent(e.target.value);
        } else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }
    };

    const isValid = () => {
        if (!dataItem.Name || dataItem.Name == "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_name_error_message });
            return false;
        }
        if(!dataItem.Language ||Object.keys(dataItem.Language).length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_language_error_message });
            return false
        }
        return true;
    }

    const handleSubmit = async () => {

        if (!isValid()) return;

        const saveData = {
            _id: !item?.copy ? dataItem._id : null,
            SID: !item?.copy ? dataItem.SID ?? 0 : 0,
            Name: dataItem.Name ?? "",
            parent: parent._id ?? null,
            Language: dataItem?.Language && Object.keys(dataItem?.Language)?.length > 0 ? {
                _id: dataItem?.Language?._id,
                ISOCode: dataItem?.Language?.ISOCode,
                Description: dataItem?.Language?.Description
            } : {},
            Archive: dataItem.Archive ?? false,
            checkDuplicate: true,
            query: [[" Name", "=", dataItem.Name], ["Language._id", "=", dataItem?.Language?._id]],
        }
        console.log(saveData);
        let res = await API.saveData(ENTITYNAME.ContentCategory, saveData);
        if (res.success) {
            let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.CONTENT_CATEGORY, data: res.data, message: res.message };
            API.SaveLogs(logData);
            utility.deleteLocalStorageItem(ENTITYNAME.ContentCategory);
            if(dataItem?._id){
                // update content category to used in content
                await API.updateContentCategoryLinks({ data: res.data });
            }
            cancelEdit();
            refresh();
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    }

    return (
        <>
            <BossDialog
                title={item?._id ? item?.Name : lang.content_category_header}
                onClose={props.cancelEdit}
                width="420px"
            >
                <EditPageHeader onSubmit={handleSubmit} onCancel={props.cancelEdit} showTitle={false} />

                <div className="row mt-2">
                    <div className="col">
                        <label>{lang.name_label} *</label>
                        <input
                            name={"Name"}
                            type="text"
                            className="form-control form-control-sm"
                            onChange={onChange}
                            value={dataItem.Name}
                        />
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col">
                        <label>{lang.parent_label}</label>
                        <DropDownList
                            data={parents}
                            name={"parent"}
                            textField="Name"
                            dataItemKey="_id"
                            value={parent}
                            onChange={onChange}
                        />
                        <p className="list-unstyled blockquote-footer">{lang.note_for_parent_select_root_label}</p>

                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <label>{lang.language_label} *</label>
                        <DropDownList
                            data={languages}
                            name="Language"
                            textField="Description"
                            dataItemKey="_id"
                            value={dataItem.Language}
                            onChange={onChange}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col mt-3">
                        <input
                            type="checkbox"
                            name="Archive"
                            value={dataItem.Archive}
                            checked={dataItem.Archive}
                            onChange={onChange}
                        />
                        <label htmlFor="TabView" className="pl-1">{lang.archive}</label>
                    </div>
                </div>

            </BossDialog>
        </>)
};

export default ContentCategoryEditForm;